/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { BlogData } from './BlogData'
import {
  BlogDataFromJSON,
  BlogDataFromJSONTyped,
  BlogDataToJSON,
} from './BlogData'
import type { SitePagination } from './SitePagination'
import {
  SitePaginationFromJSON,
  SitePaginationFromJSONTyped,
  SitePaginationToJSON,
} from './SitePagination'

/**
 *
 * @export
 * @interface GetBlogList200Response
 */
export interface GetBlogList200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetBlogList200Response
   */
  status: boolean
  /**
   *
   * @type {BlogData}
   * @memberof GetBlogList200Response
   */
  data: BlogData
  /**
   *
   * @type {SitePagination}
   * @memberof GetBlogList200Response
   */
  paginate: SitePagination
}

/**
 * Check if a given object implements the GetBlogList200Response interface.
 */
export function instanceOfGetBlogList200Response(
  value: object
): value is GetBlogList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  if (!('paginate' in value) || value['paginate'] === undefined) return false
  return true
}

export function GetBlogList200ResponseFromJSON(
  json: any
): GetBlogList200Response {
  return GetBlogList200ResponseFromJSONTyped(json, false)
}

export function GetBlogList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetBlogList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: BlogDataFromJSON(json['data']),
    paginate: SitePaginationFromJSON(json['paginate']),
  }
}

export function GetBlogList200ResponseToJSON(
  value?: GetBlogList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: BlogDataToJSON(value['data']),
    paginate: SitePaginationToJSON(value['paginate']),
  }
}
